import { Component, OnInit } from '@angular/core';
import { AlertService } from '@service/alert.service';
import { Subject, takeUntil, timer } from 'rxjs';

@Component({
  selector: 'alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {
  data: any;
  newCallData: any;
  UnsubscribeAll: Subject<any> = new Subject()

  constructor(
    private alertService: AlertService
  ) {
      this.alertService.getMessage()
        .pipe(takeUntil(this.UnsubscribeAll))
        .subscribe(message => {
          if(message){
            this.data = message;
            timer(4000).subscribe((res)=>{
              this.data = undefined;
            })
          }
      });

      this.alertService.getUnReadCalls()
        .pipe(takeUntil(this.UnsubscribeAll))
        .subscribe(
          (data)=>{
            if(data){
              this.newCallData = data;
              timer(4000).subscribe((res)=>{ 
                this.newCallData = undefined;
              })
            }
          })
  }

  ngOnInit() {
  }
  close() {
      this.data = undefined;
  }
  ngOnDestroy() {
      this.UnsubscribeAll.next(null)
      this.UnsubscribeAll.complete();
  }

}
